export default __webpack_public_path__ + "static/media/Gerador-documentation.df6196e6.md";